<div class="cards-container">
  <ng-container *ngIf="hostels">
    <ng-container *ngFor="let hostel of hostels; let i = index; trackBy: trackById">
      <app-card class="mobile" [hostel]="hostel" [skeleton]="skeleton" [currency]="currency | async" [i]="i" (click)="navigateToHostelDetails(hostel)"></app-card>
    </ng-container>
  </ng-container>
  <ng-container *ngIf="skeleton">
    <app-skeleton-card class="mobile" *ngFor="let hostel of mockHostels"></app-skeleton-card>
  </ng-container>
</div>
